/**
 * @generated SignedSource<<813d06408ec53c27bc0c0a176014c454>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type confluenceTemplateDetailsRelayPageQuery$variables = {
  locale: string;
  urlSlug: string;
};
export type confluenceTemplateDetailsRelayPageQuery$data = {
  readonly templates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string | null | undefined;
        readonly pluginModuleKey: string;
        readonly templateId: string;
        readonly " $fragmentSpreads": FragmentRefs<"templateCategorySectionRelayFragment" | "templateDetailsSectionRelayFragment" | "templateHeaderSectionRelayFragment" | "templateKeyFeaturesSectionRelayFragment">;
      };
    }>;
  };
};
export type confluenceTemplateDetailsRelayPageQuery = {
  response: confluenceTemplateDetailsRelayPageQuery$data;
  variables: confluenceTemplateDetailsRelayPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locale"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "urlSlug"
  }
],
v1 = [
  {
    "fields": [
      {
        "fields": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 1
          },
          {
            "fields": [
              {
                "fields": [
                  {
                    "fields": [
                      {
                        "kind": "Literal",
                        "name": "fieldNamed",
                        "value": "urlSlug"
                      },
                      {
                        "items": [
                          {
                            "kind": "Variable",
                            "name": "havingValues.0",
                            "variableName": "urlSlug"
                          }
                        ],
                        "kind": "ListValue",
                        "name": "havingValues"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "exactlyMatching"
                  }
                ],
                "kind": "ObjectValue",
                "name": "searchText"
              }
            ],
            "kind": "ObjectValue",
            "name": "where"
          },
          {
            "items": [
              {
                "kind": "Variable",
                "name": "withLocales.0",
                "variableName": "locale"
              }
            ],
            "kind": "ListValue",
            "name": "withLocales"
          }
        ],
        "kind": "ObjectValue",
        "name": "queries"
      }
    ],
    "kind": "ObjectValue",
    "name": "search"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pluginModuleKey",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v6 = [
  (v3/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentPlatformOrganization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "kind": "InlineFragment",
  "selections": (v6/*: any*/),
  "type": "ContentPlatformOrganization",
  "abstractKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentPlatformTaxonomyTemplateType",
  "kind": "LinkedField",
  "name": "templateType",
  "plural": true,
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateTypeName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlSlug",
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "confluenceTemplateDetailsRelayPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContentPlatformTemplateContentSearchConnection",
        "kind": "LinkedField",
        "name": "templates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentPlatformTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "templateHeaderSectionRelayFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "templateKeyFeaturesSectionRelayFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "templateCategorySectionRelayFragment"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "templateDetailsSectionRelayFragment"
                  },
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "confluenceTemplateDetailsRelayPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ContentPlatformTemplateContentSearchConnection",
        "kind": "LinkedField",
        "name": "templates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentPlatformTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "oneLinerHeadline",
                    "storageKey": null
                  },
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "contributor",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "jobTitle",
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "type": "ContentPlatformAuthor",
                        "abstractKey": null
                      },
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTaxonomyFeature",
                    "kind": "LinkedField",
                    "name": "keyFeatures",
                    "plural": true,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": "categories",
                    "args": null,
                    "concreteType": "ContentPlatformCategory",
                    "kind": "LinkedField",
                    "name": "category",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v3/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "templatePreviews",
                    "args": null,
                    "concreteType": "ContentPlatformTemplateImageAsset",
                    "kind": "LinkedField",
                    "name": "templatePreview",
                    "plural": true,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "aboutThisTemplate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplateOverview",
                    "kind": "LinkedField",
                    "name": "templateOverview",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "overviewTitle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "overviewDescription",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplateBenefitContainer",
                    "kind": "LinkedField",
                    "name": "templateBenefits",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "benefitsTitle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentPlatformTemplateBenefit",
                        "kind": "LinkedField",
                        "name": "templateBenefitContainer",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shortDescription",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplateGuide",
                    "kind": "LinkedField",
                    "name": "howToUseThisTemplate",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentPlatformTemplateUseStep",
                        "kind": "LinkedField",
                        "name": "steps",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentPlatformTemplateImageAsset",
                            "kind": "LinkedField",
                            "name": "asset",
                            "plural": false,
                            "selections": (v12/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplateProductRationale",
                    "kind": "LinkedField",
                    "name": "templateProductRationale",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rationaleTitle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "templateProductRationaleDescription",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplate",
                    "kind": "LinkedField",
                    "name": "relatedTemplates",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v11/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "previewBlurb",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "contributor",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v8/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v7/*: any*/)
                            ],
                            "type": "ContentPlatformAuthor",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "df8f7e8d2fadfb0178ce017fedf07603",
    "id": null,
    "metadata": {},
    "name": "confluenceTemplateDetailsRelayPageQuery",
    "operationKind": "query",
    "text": "query confluenceTemplateDetailsRelayPageQuery(\n  $locale: String!\n  $urlSlug: String!\n) {\n  templates(search: {queries: {first: 1, withLocales: [$locale], where: {searchText: {exactlyMatching: {fieldNamed: \"urlSlug\", havingValues: [$urlSlug]}}}}}) {\n    edges {\n      node {\n        templateId\n        ...templateHeaderSectionRelayFragment\n        ...templateKeyFeaturesSectionRelayFragment\n        ...templateCategorySectionRelayFragment\n        ...templateDetailsSectionRelayFragment\n        name\n        pluginModuleKey\n      }\n    }\n  }\n}\n\nfragment templateAuthorRelayFragment on ContentPlatformTemplate {\n  contributor {\n    __typename\n    ... on ContentPlatformAuthor {\n      name\n      jobTitle\n      organization {\n        name\n      }\n    }\n    ... on ContentPlatformOrganization {\n      name\n    }\n  }\n}\n\nfragment templateBenefitsRelayFragment on ContentPlatformTemplateBenefitContainer {\n  benefitsTitle\n  templateBenefitContainer {\n    name\n    shortDescription\n  }\n}\n\nfragment templateCardRelayFragment on ContentPlatformTemplate {\n  templateId\n  name\n  urlSlug\n  pluginModuleKey\n  previewBlurb\n  templateType {\n    id\n    templateTypeName\n  }\n  contributor {\n    __typename\n    ... on ContentPlatformOrganization {\n      name\n    }\n    ... on ContentPlatformAuthor {\n      organization {\n        name\n      }\n    }\n  }\n}\n\nfragment templateCategorySectionRelayFragment on ContentPlatformTemplate {\n  templateType {\n    id\n    templateTypeName\n  }\n  categories: category {\n    id\n    name\n    urlSlug\n  }\n}\n\nfragment templateDescriptionRelayFragment on ContentPlatformTemplate {\n  aboutThisTemplate\n}\n\nfragment templateDetailsSectionRelayFragment on ContentPlatformTemplate {\n  name\n  pluginModuleKey\n  templateType {\n    id\n    templateTypeName\n  }\n  ...templatePreviewRelayFragment\n  ...templateDescriptionRelayFragment\n  ...templateTabbedSectionRelayFragment\n  ...templateRelatedTemplatesRelayFragment\n}\n\nfragment templateGuideRelayFragment on ContentPlatformTemplateGuide {\n  name\n  steps {\n    name\n    description\n    asset {\n      url\n    }\n  }\n}\n\nfragment templateHeaderSectionRelayFragment on ContentPlatformTemplate {\n  name\n  oneLinerHeadline\n  pluginModuleKey\n  ...templateAuthorRelayFragment\n}\n\nfragment templateKeyFeaturesSectionRelayFragment on ContentPlatformTemplate {\n  keyFeatures {\n    name\n  }\n}\n\nfragment templatePreviewRelayFragment on ContentPlatformTemplate {\n  name\n  templateType {\n    id\n  }\n  templatePreviews: templatePreview {\n    url\n  }\n}\n\nfragment templateRelatedTemplatesRelayFragment on ContentPlatformTemplate {\n  relatedTemplates {\n    templateId\n    ...templateCardRelayFragment\n  }\n}\n\nfragment templateTabbedSectionRelayFragment on ContentPlatformTemplate {\n  templateOverview {\n    overviewTitle\n    overviewDescription\n  }\n  templateBenefits {\n    ...templateBenefitsRelayFragment\n  }\n  howToUseThisTemplate {\n    ...templateGuideRelayFragment\n  }\n  templateProductRationale {\n    rationaleTitle\n    templateProductRationaleDescription\n  }\n}\n"
  }
};
})();

(node as any).hash = "978aa2c3ffdfcc73a88a375ca658ddbf";

export default node;
